module.exports = __webpack_public_path__ + "static/img/14.202ebdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/14.png
// module id = 22Za
// module chunks = 0